import SArray, { SDataArray } from 's-array';

import { Berth as ServerBerth, BerthOptions } from 'server/models/Berth';
import { BerthReservation } from 'data/models/BerthReservation';
import { Measurement } from 'data/models/Measurement';
import { UnlistedBerthReservation } from 'data/models/UnlistedBerthReservation';

export { BerthData, BerthOptions } from 'server/models/Berth';

export class Berth extends ServerBerth {
    UnlistedReservations : SDataArray<UnlistedBerthReservation>;

    constructor();
    constructor(data : BerthOptions);
    constructor(data : BerthOptions | null = null) {
        super(data || { Id: 0 });
        this.UnlistedReservations = SArray<UnlistedBerthReservation>([]);
    }

    static readonly StartMarkOrder = (b1 : Berth, b2 : Berth) => {
        const b2StartMark = b2.StartMark.convert(b1.StartMark.UOM());
        let b2Length : Measurement;
        return b1.StartMark.Num() < b2StartMark.Num() ? -1 :
            b1.StartMark.Num() > b2StartMark.Num() ? 1 :
            b1.Length.Num() < (b2Length = b2.Length.convert(b1.Length.UOM())).Num() ? -1 :
            b1.Length.Num() > b2Length.Num() ? 1 :
            b1.Id() < b2.Id() ? -1 :
            b1.Id() > b2.Id() ? 1 :
            0;
    };

    Reservations() {
        const loc = this.Location(),
              pts = loc && loc.Itinerary() || [],
              reses = [] as BerthReservation[];
        for (let pt of pts) {
            let res = pt.BerthReservation();
            if (res) reses.push(res);
        }
        return reses;
    }
}


// WEBPACK FOOTER //
// ./data/models/Berth.ts